export const SEO_CITY_TEMPLATE = 'SEO_City_Template';
export const SEO_CITY_HR_TEMPLATE = 'SEO_City_HR_Template';
export const SEO_CITY_OPERATOR_TEMPLATE = 'SEO_City_Operator_Template';
export const SEO_CITY_CARTYPE_TEMPLATE = 'SEO_City_Car_Type_Template';
export const SEO_CITY_RYDE_TEMPLATE = 'SEO_City_Ryde_Template';

export const SEO_ROUTE_TEMPLATE = 'SEO_Route_Template';
export const SEO_ROUTE_TEMPLATE_ISOMORPHIC = 'SEO_Route_Template_Isomorphic';
export const SEO_ROUTE_TEMPLATE_REVIEW_LINK = 'SEO_Route_Template_Review_Link';
export const SEO_ROUTE_OPERATOR_TEMPLATE = 'SEO_Route_Operator_Template';
export const SEO_ROUTE_CARTYPE_TEMPLATE = 'SEO_Route_Car_Type_Template';
export const SEO_ROUTE_RYDE_TEMPLATE = 'SEO_Route_Ryde_Template';

export const SEO_OPERATOR_TEMPLATE = 'SEO_Operator_Template';
export const SEO_AIRPORT_TEMPLATE = 'SEO_Airport_Template';

export const SEO_RYDE_HOME_PAGE = 'SEO_Ryde_Home_Page';
export const SEO_OS_HOME_PAGE = 'SEO_OS_Home_Page';
export const SEO_AIRPORT_HOME_PAGE = 'SEO_Airport_Home_Page';
export const SEO_RENTAL_HOME_PAGE = 'SEO_Rental_Home_Page';
export const SEO_A2C_ROUTE_TEMPLATE = 'SEO_A2C_Route_Template';
export const SEO_CABS_LANDING_PAGE = 'SEO_Cabs_Landing_Page';
export const STATIC_CAB_FAQ_PAGE = 'Static_Cab_Faq_Page';

export const SEO_LANDING = 'seo-landing';
